import { ViewModel } from "@/lib/vm/viewmodel"

export class ControlViewModel extends ViewModel
   constructor: (template, order) ->
      assertArgs(arguments, String, Number)
      super(template)
      @order = ko.observable(order)
      @isVisible = ko.observable(true)

